import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import API from './api';

function ReportPrint() {
  const { id } = useParams();
  const [report, setReport] = useState(null);
  const [groupedSkills, setGroupedSkills] = useState({});

  useEffect(() => {
    fetchReport();
  }, []);

  const fetchReport = async () => {
    try {
      const res = await API.get(`/reports/${id}/view`);
      const { report, skills } = res.data;

      setReport(report);

      const grouped = {};
      skills.forEach(skill => {
        if (!grouped[skill.domain]) grouped[skill.domain] = [];
        grouped[skill.domain].push(skill);
      });
      setGroupedSkills(grouped);
    } catch (err) {
      alert('Failed to load report data');
    }
  };

  const domainLabels = {
    cognitive: 'Cognitive',
    language: 'Language',
    gross_motor: 'Gross Motor',
    fine_motor: 'Fine Motor',
    social: 'Social',
    self_help: 'Self Help',
    other: 'Other'
  };

  return (
    <div className="p-6 print:p-2 text-sm">
      {report ? (
        <>
          <h1 className="text-2xl font-bold mb-1">Student Progress Report</h1>
          <div className="mb-4">
            <div><strong>Student:</strong> {report.student_first_name} {report.student_last_name}</div>
            <div><strong>Teacher:</strong> {report.teacher_name}</div>
            <div><strong>Period:</strong> {report.date_from} to {report.date_to}</div>
            <div><strong>Report Type:</strong> {report.type}</div>
            {report.summary && (
              <div className="mt-2">
                <strong>Summary:</strong>
                <div className="whitespace-pre-line border p-2 rounded mt-1 bg-gray-100">{report.summary}</div>
              </div>
            )}
          </div>

          {Object.entries(groupedSkills).map(([domain, skills]) => (
            <div key={domain} className="mb-6">
              <h2 className="text-lg font-semibold mb-2">{domainLabels[domain] || domain}</h2>
              <table className="w-full border table-auto">
                <thead className="bg-gray-100">
                  <tr>
                    <th className="border p-1">Code</th>
                    <th className="border p-1">Skill</th>
                    <th className="border p-1">Age</th>
                    <th className="border p-1">Baseline</th>
                    <th className="border p-1">Status</th>
                    <th className="border p-1">Assessed</th>
                    <th className="border p-1">Note</th>
                  </tr>
                </thead>
                <tbody>
                  {skills.map(skill => (
                    <tr key={skill.id}>
                      <td className="border p-1 text-center">{skill.code}</td>
                      <td className="border p-1">{skill.name}</td>
                      <td className="border p-1 text-center">{skill.age_range}</td>
                      <td className="border p-1 text-center">{skill.is_baseline ? 'Yes' : ''}</td>
                      <td className="border p-1 text-center">{skill.status}</td>
                      <td className="border p-1 text-center">{skill.assessed_at || '–'}</td>
                      <td className="border p-1">{skill.note || ''}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ))}
        </>
      ) : (
        <div>Loading...</div>
      )}
    </div>
  );
}

export default ReportPrint;

